import FundingRateInfo from 'src/components/PerpPageStats/FundingRateInfo';
import MarketBar from 'src/components/MarketBar/MarketBar';
import { MarketSelectorDisplay } from 'src/components/MarketSelector';
// import RecentMarketTrades from 'src/components/RecentMarketTrades';
import TradeForm from 'src/components/TradeForm/TradeForm';
import TradePageTable from 'src/components/TradePageTable/TradePageTable';
import React, { useEffect, useRef, useState } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import MobileTopDrawer from '../MobileTopDrawer';
import MobileChartAndOrderbook from '../MobileChartAndOrderbook';
import { useWindowSizeStore } from 'src/stores/useWindowSizeStore';

const MobileTradePage = () => {
	const selectedMarketType = useDriftStore(
		(s) => s.selectedMarket.current.marketType
	);
	const marketBarRef = useRef<HTMLDivElement>(null);
	const fundingRateBarRef = useRef<HTMLDivElement>(null);
	const windowHeight = useWindowSizeStore((s) => s.realtimeHeight);

	const [tableMinHeight, setTableMinHeight] = useState(0);

	useEffect(() => {
		const marketBarHeight = marketBarRef.current?.clientHeight ?? 0;
		const fundingRateBarHeight = fundingRateBarRef.current?.clientHeight ?? 0;
		const headerHeight = document.querySelector('.header')?.clientHeight ?? 0;

		setTableMinHeight(
			windowHeight - marketBarHeight - fundingRateBarHeight - headerHeight
		);
	}, [windowHeight, fundingRateBarRef.current, marketBarRef.current]);

	return (
		<>
			<MobileTopDrawer />

			<div className="subheader bg-container-bg">
				<MarketBar />
			</div>

			<div
				className="z-50 p-0 border-b rounded-md funding-rate-container bg-container-bg border-container-border md:p-2"
				ref={marketBarRef}
			>
				<MarketSelectorDisplay mobile />
			</div>

			<div className="z-50" ref={fundingRateBarRef}>
				<FundingRateInfo mobile />
			</div>

			<main className="main hidden-scroll">
				<div className="space-y-8 main-overview">
					<div className="buyandsellcontaniner">
						<div className="topcontainer">
							<MobileChartAndOrderbook />
							<div className="buyandsell bg-container-bg md:rounded-md">
								<TradeForm marketType={selectedMarketType} />
							</div>
						</div>
					</div>

					<div
						className="block sm:hidden bg-container-bg"
						style={{ minHeight: `${tableMinHeight}px` }}
					>
						<TradePageTable />
					</div>
				</div>
			</main>
		</>
	);
};

export default MobileTradePage;
